<template>
  <div class="editor">
    <!--
    <a href="#" @click="setList">list</a>
    -->
    <link-generator ref="generator"></link-generator>
    <base-editor
      :value="contentFullHtml"
      ref="editor"
      @input="onInput"
      @click="onContentClick"
      @keydown="onKeyDown"
    >
      <div
        class="header"
        slot="pre-content"
      >
        <div class="udc">
          УДК 000
        </div>
      </div>
      <div
        class="footer"
        slot="post-content"
      >
        <slot name="lit-list"></slot>
      </div>
    </base-editor>
    <!--
    <textarea
      ref="doc"
    >
      <div class="udc">УДК ???</div>
      <h1
        class="article-title"
        mceEditable
      >Название статьи</h1>
      <div
        class="article-content"
        mceEditable
      >
        {{ value }}
      </div>
    </textarea>
    -->
  </div>
</template>

<script>
/*
import tinymce from 'tinymce/tinymce'
import 'tinymce/themes/modern/theme'
import 'tinymce/skins/lightgray/skin.min.css'
import 'tinymce/skins/lightgray/content.min.css'
*/
import $ from 'jquery'
export default {
  components: {
    LinkGenerator: require('./LinkGenerator.vue'),
    BaseEditor: require('./BaseEditor.vue')
  },
  data () {
    return {
      editor: null,
      editingSubElement: null,
      editingType: null
    }
  },
  props: {
    contentHtml: String,
    docName: String,
    udc: String,
    links: {
      type: Object
    }
  },
  computed: {
    contentFullHtml () {
      let content = ''
      content += '<div class="udc">УДК ' +  _.escape(this.udc) + '</div>'
      if (this.docName) {
        content += '<h1 class="doc-name">' + _.escape(this.docName) + '</h1>'
      } else {
        content += '<h1 class="doc-name stub">Название статьи</h1>'
      }
      content += '<div class="content" contenteditable="true">' + this.contentHtml + '</div>'
      return content
    }
  },
  watch: {
    links (links) {
      this.$nextTick(() => {
        this.updateLinks(links)
      })
    }
  },
  methods: {
    onKeyDown (event) {
      if (event.which === 13 && this.editingType === 'doc-name') {
        this.onEditingDocNameEnd()
        this.$refs.editor.removeFocus()
      }
    },
    onContentClick (event) {
      if (event.target.classList.contains('doc-name')) {
        this.onEditingDocNameStart(event.target)
      }
      if (event.target.classList.contains('content-stub')) {
        this.onEditingContentStart(event.target)
      }
      // console.log(event)
      // document rename feature
      /*
      if (event.target.classList.contains('doc-name')) {
        if (event.target.classList.contains('stub')) {
          event.target.classList.remove('stub')
          event.target.innerText = ''
          event.target.focus()
        }
        event.target.setAttribute('contenteditable', 'true')
        var onEdited = () => {
          this.$emit('set-doc-name', event.target.innerText)
          event.target.removeAttribute('contenteditable')
          event.target.removeEventListener('blur', onEdited)
          window.removeEventListener('keydown', keyListener)
        }
        var keyListener = (event) => {
          if (event.which === 13) {
            this.onEdited()
          }
        }
        event.target.addEventListener('blur', onEdited)
        window.addEventListener('keydown', keyListener)
      }
      */
    },
    onEditingContentStart (element) {
      const newElement = document.createElement('div')
      const innerElement = document.createElement('br')

      element.parentElement.insertBefore(newElement, element)
      element.parentElement.insertBefore(innerElement, element)
      element.remove()

      const editor = this.$refs.editor
      const selection = editor.getContentWindow().getSelection()
      const range = editor.getContentDocument().createRange()
      range.selectNodeContents(newElement)
      selection.removeAllRanges()
      selection.addRange(range)
    },
    onEditingDocNameStart (element) {
      this.editingSubElement = element
      this.editingType = 'doc-name'

      if (element.classList.contains('stub')) {
        element.classList.remove('stub')
        element.innerText = ''
      }
      element.setAttribute('contenteditable', 'true')
      element.addEventListener('blur', this.onEditingDocNameEnd)
      setTimeout(() => {
        element.focus()
      }, 0)
    },
    onEditingDocNameEnd () {
      this.$emit('set-doc-name', this.editingSubElement.innerText)
      this.editingSubElement.removeAttribute('contenteditable')
      this.editingSubElement.removeEventListener('blur', this.onEditingDocNameEnd)

      this.editingSubElement = null
      this.editingType = null
    },
    editorUndo () {
      this.editor.execCommand('undo')
    },
    editorRedo () {
      this.editor.execCommand('redo')
    },
    editorCopy () {
      this.editor.execCommand('Copy')
    },
    editorCut () {
      this.editor.execCommand('Cut')
    },
    editorPaste () {
      this.editor.execCommand('Paste')
    },
    editorHeader () {
      this.editor.focus()
      this.editor.selection.setContent('<h2>' + this.editor.selection.getContent() + '</h2>')
    },
    editorList () {
      this.editor.execCommand('InsertUnorderedList')
    },
    updateLinks (links) {
      /*
      Object.keys(links).forEach((linkId) => {
        const linkLabel = links[linkId]
        const $element = this.editor.dom.$('.link[data-link="' + linkId + '"]')
        const currentContent = $element.attr('data-label')
        if (linkLabel !== currentContent) {
          const newImage = this.$refs.generator.generate(linkLabel)
          const newElement = $('<img>').addClass('link').attr('src', newImage).attr('data-link', linkId).attr('data-label', linkLabel)
          $element.replaceWith(newElement)
        }
      })
      */
    },
    addLink (linkId) {
      const image = this.$refs.generator.generate('[1]')
      // this.editor.focus()
      // this.editor.insertContent('<img class="link" src="' + image + '" data-link="' + linkId + '" data-label="[1]"/>') 
      this.$refs.editor.insertContent('<img class="link" src="' + image + '" data-link="' + linkId + '" data-label="[1]"/>')
    },
    onUpdateContent (content) {
      this.$emit('input', content)
    },
    openAddSourceDialog () {
      this.$emit('add-source')
    },
    export (format) {
      this.$emit('export', format)
    },
    forceUpdateContent (content) {
      this.editor.setContent(content);
    },
    onChange() {
      if (this.editor) {
        this.$emit('input', this.editor.getContent())
      }
    },
    onInput (value) {
      this.$emit('input', value)
      // console.log('value')
    }
  },
  mounted () {
    /*
    $('html', this.$refs.editor.$el).on('click', 'h1.stub', (event) => {
      $(event.currentTarget).attr('contenteditable', 'true').focus()
    })
    */
    /*
    tinymce.init({
      target: this.$refs.doc,
      height: 300,
      menubar: false,
      plugins: ['lists', 'noneditable'],
      // toolbar: 'undo redo |  underline_custom | bullist | link | pdf doc',
      toolbar: false,
      // body_class: 'mceNonEditable',
      content_css: '/static/tinymce.css',
      init_instance_callback: (ed) => {
        ed.getBody().contentEditable = false
      },
      setup : (ed) => {
        // ed.body.contentEditable = false
        ed.on('click', (e) => {
          // handle link click to edit
          if (e.target.classList.contains('link')) {
            const linkId = e.target.getAttribute('data-link')
            this.$emit('edit-link', linkId)
          }
        })
        ed.on('nodeChange', (e) => {
          this.onChange()
        })
        ed.on('keyup', (e) => {
          this.onChange()
        })
        ed.on('paste', (e) => {
          this.onChange()
        })
        ed.on('change', (e) => {
          this.onChange()
        })
        ed.addButton('underline_custom', {
          title : 'U',
          icon: 'underline',
          onclick : function() {
            ed.focus()
            ed.selection.setContent('<u>' + ed.selection.getContent() + '</u>')
          }
        })
        ed.addButton('link', {
          text: 'Ссылка',
          icon: null,
          onclick: this.openAddSourceDialog
        })
        ed.addButton('pdf', {
          text: 'PDF',
          icon: null,
          onclick: () => this.export('pdf')
        })
        ed.addButton('doc', {
          text: 'DOC',
          icon: null,
          onclick: () => this.export('doc')
        })
      }

    }).then((result) => {
      this.editor = result[0]
      this.editor.dom.$('html').attr('lang', 'ru')
    }).catch((err) => {
      this.handleError(err)
    })
    */
  }
}
</script>

<style lang="sass">
.editor
  height: 100%
</style>


// WEBPACK FOOTER //
// ArticleView.vue?dac2bc22